<template>
  <div class="bottom-navigation">
    <a class="group" href="/" :class="{ active: hasHomeActive }">
      <v-icon
        v-if="hasHomeActive"
        icon="home-solid"
        size="6"
        class="text-black-40"
      ></v-icon>
      <v-icon v-else icon="home" size="6" class="text-black-40"></v-icon>
      <label class="mt-2 text-small-text-medium text-black-40">Domov</label>
    </a>

    <v-search-lightbox
      :current-country="currentCountry"
      :i18n="headerSetupData.i18n"
      :unparsed-enums="headerSetupData.enums"
      :errors="{}"
      :query="headerSetupData.query"
      parent-class="w-full"
    >
      <template v-slot:lightbox-trigger class="w-full">
        <a class="group" :class="{ active: hasSearchActive }">
          <v-icon icon="loupe" size="6" class="text-black-40"></v-icon>
          <label class="mt-2 text-small-text-medium text-black-40">Iščite</label
          >
        </a>
      </template>
    </v-search-lightbox>

    <template v-if="!headerSetupData.isAuthenticated">
      <v-login
        :login-show="false"
        :login-error="headerSetupData.loginError"
        :facebook-login-route="headerSetupData.facebookLoginRoute"
                            :google-login-route="headerSetupData.googleLoginRoute"
        :login-post-route="headerSetupData.loginPostRoute"
        :register-route="headerSetupData.registerRoute"
        :forgot-password-route="headerSetupData.forgotPasswordRoute"
        :csrf-token="headerSetupData.csrfToken"
      >
        <template v-slot:trigger>
          <a class="group">
            <v-icon icon="circle-add" size="6" class="text-black-40"></v-icon>
            <label class="mt-2 text-small-text-medium text-black-40">Objavite</label
            >
          </a>
        </template>
      </v-login>
    </template>

    <a
      v-if="headerSetupData.isAuthenticated"
      :href="headerSetupData.createListingRoute"
      class="group"
      :class="{ active: hasAddListingActive }"
    >
      <v-icon
        v-if="hasAddListingActive"
        icon="circle-add-solid"
        size="6"
        class="text-black-40"
      ></v-icon>
      <v-icon v-else icon="circle-add" size="6" class="text-black-40"></v-icon>
      <label class="mt-2 text-small-text-medium text-black-40">Objavite</label
      >
    </a>

    <template v-if="!headerSetupData.isAuthenticated">
      <v-login
        :login-show="false"
        :facebook-login-route="headerSetupData.facebookLoginRoute"
        :google-login-route="headerSetupData.googleLoginRoute"
        :login-error="headerSetupData.loginError"
        :login-post-route="headerSetupData.loginPostRoute"
        :register-route="headerSetupData.registerRoute"
        :forgot-password-route="headerSetupData.forgotPasswordRoute"
        :csrf-token="headerSetupData.csrfToken"
      >
        <template v-slot:trigger>
          <a class="group">
            <v-icon
              icon="account-circle"
              size="6"
              class="text-black-40"
            ></v-icon>
            <label class="mt-2 text-small-text-medium text-black-40">Prijava</label
            >
          </a>
        </template>
      </v-login>
    </template>

    <a
      v-if="headerSetupData.isAuthenticated"
      :href="headerSetupData.profileRoute"
      class="group"
      :class="{ active: hasProfileActive }"
    >
      <img
        :src="$assetsUrl + '/images/profile.webp'"
        class="pointer-events-none h-6 w-6 select-none"
      />
      <label class="mt-2 text-small-text-medium text-black-40">Profil</label
      >
    </a>
  </div>
</template>

<script>
export default {
  props: {
    hasHomeActive: {
      type: Boolean,
      default: false,
    },
    hasSearchActive: {
      type: Boolean,
      default: false,
    },
    hasAddListingActive: {
      type: Boolean,
      default: false,
    },
    hasProfileActive: {
      type: Boolean,
      default: false,
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    headerSetupData: {
      type: Object,
      required: true,
    },
    isOnListing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentCountry() {
      if (this.headerSetupData.country == "SVN") {
        return "Slovenija";
      } else {
        return "Hrvaška";
      }
    },
  },
  mounted() {},
};
</script>
